import fetchApi from '../../Services/requests';
import { EditProfileUrl, ProfileDataUrl } from '../../Routes/profile.route';
import useLandingStore from '../Landing';

export const getProfileDataAction = async (set, clubBranchId: number) => {
  const uniqueId = useLandingStore.getState().landingData?.uniqueId;
  set({ profileData: null, profileLoading: true, profileError: false });

  const response = await fetchApi(ProfileDataUrl(), {
    clubBranchId,
    uniqueId
  });

  response?.ok
    ? set({
        profileData: response.data,
        profileLoading: false,
        profileError: false
      })
    : set({ profileData: null, profileLoading: false, profileError: true });
  return response?.ok;
};

export const editProfileDataAction = async (
  set,
  body: {
    clubBranchId: number;
    name?: string;
    sex?: string;
    email?: string;
    birthday?: string;
  }
): Promise<boolean> => {
  const uniqueId = useLandingStore.getState().landingData?.uniqueId;
  set({ editProfileLoading: true, editProfileError: false });

  const response = await fetchApi(EditProfileUrl(), { ...body, uniqueId });

  response?.ok
    ? set((state) => ({
        editProfileLoading: false,
        editProfileError: false,
        profileData: { ...state.profileData, ...body }
      }))
    : set({ editProfileLoading: false, editProfileError: true });
  return response.ok;
};
